/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Configure_The_Ai_Concierge_ThaInputs */

const en_configure_the_ai_concierge_tha = /** @type {(inputs: Configure_The_Ai_Concierge_ThaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configure the AI Concierge that represents your store 24/7.`)
};

const es_configure_the_ai_concierge_tha = /** @type {(inputs: Configure_The_Ai_Concierge_ThaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configura el Conserje IA que representa tu tienda 24/7.`)
};

const fr_configure_the_ai_concierge_tha = /** @type {(inputs: Configure_The_Ai_Concierge_ThaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configurez le concierge IA qui représente votre boutique 24h/24 et 7j/7.`)
};

const de_configure_the_ai_concierge_tha = /** @type {(inputs: Configure_The_Ai_Concierge_ThaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konfiguriere den KI-Concierge, der deinen Store rund um die Uhr repräsentiert.`)
};

const ja_configure_the_ai_concierge_tha = /** @type {(inputs: Configure_The_Ai_Concierge_ThaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ストアを24時間年中無休で代表するAIコンシェルジュを設定します。`)
};

const zh_configure_the_ai_concierge_tha = /** @type {(inputs: Configure_The_Ai_Concierge_ThaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`配置全天候代表您店铺的 AI 礼宾客服。`)
};

const ar_configure_the_ai_concierge_tha = /** @type {(inputs: Configure_The_Ai_Concierge_ThaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قم بضبط المساعد الذكي (الكونسيرج) الذي يمثل متجرك على مدار الساعة.`)
};

const id_configure_the_ai_concierge_tha = /** @type {(inputs: Configure_The_Ai_Concierge_ThaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konfigurasikan Pramutamu AI yang mewakili toko Anda 24/7.`)
};

const it_configure_the_ai_concierge_tha = /** @type {(inputs: Configure_The_Ai_Concierge_ThaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configura il Concierge IA che rappresenta il tuo negozio 24 ore su 24, 7 giorni su 7.`)
};

const ru_configure_the_ai_concierge_tha = /** @type {(inputs: Configure_The_Ai_Concierge_ThaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Настройте ИИ-Консьержа, который представляет ваш магазин 24/7.`)
};

const pt_configure_the_ai_concierge_tha = /** @type {(inputs: Configure_The_Ai_Concierge_ThaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configure o Concierge IA que representa sua loja 24h por dia, 7 dias por semana.`)
};

const ko_configure_the_ai_concierge_tha = /** @type {(inputs: Configure_The_Ai_Concierge_ThaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`24시간 내내 스토어를 대표할 AI 컨시어지를 구성하세요.`)
};

/**
* | output |
* | --- |
* | "Configure the AI Concierge that represents your store 24/7." |
*
* @param {Configure_The_Ai_Concierge_ThaInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const configure_the_ai_concierge_tha = /** @type {((inputs?: Configure_The_Ai_Concierge_ThaInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Configure_The_Ai_Concierge_ThaInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_configure_the_ai_concierge_tha(inputs)
	if (locale === "es") return es_configure_the_ai_concierge_tha(inputs)
	if (locale === "fr") return fr_configure_the_ai_concierge_tha(inputs)
	if (locale === "de") return de_configure_the_ai_concierge_tha(inputs)
	if (locale === "ja") return ja_configure_the_ai_concierge_tha(inputs)
	if (locale === "zh") return zh_configure_the_ai_concierge_tha(inputs)
	if (locale === "ar") return ar_configure_the_ai_concierge_tha(inputs)
	if (locale === "id") return id_configure_the_ai_concierge_tha(inputs)
	if (locale === "it") return it_configure_the_ai_concierge_tha(inputs)
	if (locale === "ru") return ru_configure_the_ai_concierge_tha(inputs)
	if (locale === "pt") return pt_configure_the_ai_concierge_tha(inputs)
	return ko_configure_the_ai_concierge_tha(inputs)
});